module.exports = __webpack_public_path__ + "img/commenicon.5a3eafe9.png";